import React, { useState, useEffect, useRef } from 'react';
import AdjustManyStyled from './AdjustManyStyled';
import { useLocation, history, useIntl } from 'umi';
import ArchiveIcon from '@material-ui/icons/Archive';
import { useDispatch, useSelector } from 'dva';
import { useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import Fab from '@material-ui/core/Fab';
import DataTableNativeML from '@/components/DataTableNativeML';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Import from '../../Import';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui//icons/Done';
import Button from '@material-ui/core/Button';
import { createOid } from '@/utils/eventtracing';
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className="tab-content"
      {...other}
    >
      {value === index && (
        <Box style={{ overflowX: 'hidden' }} className="content-wrapper">
          {children}
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const AdjustMany = () => {
  //国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const levels = useSelector((state) => state.adjustDetail.levels);
  const saveRef = useRef();
  useEffect(() => {
    dispatch({ type: 'adjustDetail/getLevels' });
  }, [dispatch]);

  const integralColumn = [
    {
      align: 'center',
      title: formatMessage({ id: 'adjustment.batch.c01.lbl01' }),
      id: 'no',
    },
    {
      title: formatMessage({ id: 'adjustment.batch.c01.lbl02' }),
      align: 'center',
      id: 'memberCode',
      key: 'memberCode',
      width: 200,
    },
    {
      align: 'center',
      title: formatMessage({ id: 'adjustment.batch.c01.lbl03' }),
      id: 'value',
      key: 'value',
    },
    {
      title: formatMessage({ id: 'adjustment.batch.c01.lbl04' }),
      align: 'center',
      id: 'remark',
      key: 'remark',
      width: 200,
    },
  ];
  const levelColumn = [
    {
      align: 'center',
      title: formatMessage({ id: 'adjustment.batch.c03.lbl01' }),
      id: 'no',
      key: 'no',
    },
    {
      title: formatMessage({ id: 'adjustment.batch.c03.lbl02' }),
      align: 'center',
      id: 'memberCode',
      key: 'memberCode',
      width: 200,
    },
    {
      align: 'center',
      title: formatMessage({ id: 'adjustment.batch.c03.lbl03' }),
      key: 'value',
      id: 'value',
    },
    {
      title: formatMessage({ id: 'adjustment.batch.c03.lbl04' }),
      align: 'center',
      id: 'remark',
      key: 'remark',
      width: 200,
    },
  ];
  // const storeColumn = [
  //   {
  //     align: 'center',
  //     title: formatMessage({ id: 'adjustment.batch.c02.lbl01' }),
  //     id: 'no',
  //   },
  //   {
  //     title: formatMessage({ id: 'adjustment.batch.c02.lbl02' }),
  //     align: 'center',
  //     id: 'memberCode',
  //     key: 'memberCode',
  //     width: 200,
  //   },
  //   {
  //     align: 'center',
  //     title: formatMessage({ id: 'adjustment.batch.c02.lbl03' }),
  //     id: 'value',
  //     key: 'value',
  //   },
  //   {
  //     title: formatMessage({ id: 'adjustment.batch.c02.lbl04' }),
  //     align: 'center',
  //     id: 'remark',
  //     key: 'remark',
  //     width: 200,
  //   },
  // ];
  // const serveColumn = [
  //   {
  //     align: 'center',
  //     title: formatMessage({ id: 'adjustment.batch.c03.lbl01' }),
  //     id: 'no',
  //     key: 'no',
  //   },
  //   {
  //     title: formatMessage({ id: 'adjustment.batch.c03.lbl02' }),
  //     align: 'center',
  //     id: 'memberCode',
  //     key: 'memberCode',
  //     width: 200,
  //   },
  //   {
  //     align: 'center',
  //     title: formatMessage({ id: 'adjustment.batch.c03.lbl03' }),
  //     key: 'value',
  //     id: 'value',
  //   },
  //   {
  //     title: formatMessage({ id: 'adjustment.batch.c03.lbl04' }),
  //     align: 'center',
  //     id: 'remark',
  //     key: 'remark',
  //     width: 200,
  //   },
  // ];
  const [columnData, setColumnData] = useState({
    integralData: [],
    levelData: [],
    storeData: [],
    serveData: [],
  });
  const [page, setPage] = useState({ pageNum: 1, pageSize: 10 });
  const rightTabArr = [
    {
      key: '1',
      name: formatMessage({ id: 'adjustment.batch.n01.lbl01' }),
      content: {
        downloadName: formatMessage({ id: 'adjustment.batch.n02.btn01' }),
        downloadAction: () =>
          window.open(
            'https://static.smgcrm.cn/apps/smg/bizgrowth/批量积分调整模板.xlsx',
          ),
        uploadName: formatMessage({ id: 'adjustment.batch.n02.btn02' }),
        column: integralColumn,
        data: columnData.integralData,
      },
    },
    // {
    //   key: '2',
    //   name: formatMessage({ id: 'adjustment.batch.n03.lbl01' }),
    //   content: {
    //     downloadName: formatMessage({ id: 'adjustment.batch.n04.btn01' }),
    //     downloadAction: () =>
    //       window.open('https://crmcdn.ecco.cn/crmii-prd/批量转柜调整模板.xlsx'),
    //     uploadName: formatMessage({ id: 'adjustment.batch.n04.btn02' }),
    //     column: storeColumn,
    //     data: columnData.storeData,
    //   },
    // },
    {
      key: '2',
      name: formatMessage({ id: 'adjustment.batch.n05.lbl01' }),
      content: {
        downloadName: formatMessage({ id: 'adjustment.batch.n06.btn01' }),
        downloadAction: () =>
          window.open(
            'https://static.smgcrm.cn/apps/smg/bizgrowth/批量等级调整模板.xlsx',
          ),
        uploadName: formatMessage({ id: 'adjustment.batch.n06.btn02' }),
        column: levelColumn,
        data: columnData.levelData,
      },
    },
    // {
    //   key: '4',
    //   name: '批量调整服务门店',
    //   content: {
    //     downloadName: '下载服务门店模版',
    //     downloadAction: () =>
    //       window.open('https://crmcdn.ecco.cn/crmii-prd/批量服务门店调整模板.xlsx'),
    //     uploadName: '批量导入服务门店',
    //     column: serveColumn,
    //     data: columnData.serveData,
    //   },
    // },
  ];
  const location = useLocation();
  const handleClickExit = () => history.goBack();

  const { query, pathname } = location;

  //保持状态
  const { tab = 1 } = query;
  const theme = useTheme();
  const handleChange = (event, newValue) => {
    history.replace({ pathname, query: { ...query, tab: newValue + 1 } });
  };
  const TYPE_MAP = {
    integralData: 'POINT',
    levelData: 'LEVEL',
    storeData: 'COUNTER',
    serveData: 'MANAGE_STORE',
  };
  const handleData = (tabName, data) => {
    let isLegal = true;
    let errorMsg = '';
    const newData = data.map((item) => {
      if (!isLegal) {
        return null;
      }
      let value = Object.values(item);
      if (value.filter((v) => v && String(v).length > 0).length !== 4) {
        isLegal = false;
        errorMsg = `数据填写不完整, 数据编号: ${value[0]}`;
      }
      if (tabName === 'integralData') {
        if (!value[2] || isNaN(Math.sign(value[2]))) {
          isLegal = false;
          errorMsg = `积分 ${value[2]} 非合法数字`;
        }
      }
      if (tabName === 'levelData') {
        const levelCodes = levels.map((s) => s.code);
        if (!levelCodes.includes(value[2])) {
          isLegal = false;
          errorMsg = `等级 ${value[2]} 不存在`;
        }
      }
      return {
        no: value[0],
        memberCode: value[1],
        value: value[2],
        remark: value[3],
        type: TYPE_MAP[tabName],
        way:
          tabName === 'integralData' ? (value[2] >= 0 ? 'ADD' : 'SUB') : null,
      };
    });
    if (!isLegal) {
      window.message.toast({
        type: 'error',
        message: errorMsg,
        title: '导入格式错误',
      });
      return;
    }
    setColumnData({ ...columnData, [tabName]: newData });
  };
  const submitChange = () => {
    const submitData = Object.values(columnData).reduce(
      (pre, cur) => pre.concat(cur),
      [],
    );
    if (!submitData.length) {
      window.message.toast({
        type: 'error',
        message: '请上传数据后再点击确认!',
        title: '确认失败',
      });
      return;
    }
    window.NE_DAWN.trigger(saveRef.current, {
      event: '_ec', // 事件名
      // params: submitData?.length ? { value: JSON.stringify(submitData) } : null, // 事件公参
    });
    dispatch({
      type: 'adjustDetail/batchMemberManualOperation',
      payload: {
        values: submitData,
      },
      callback: (res) => {
        if (res.code === 0) {
          window.message.toast({
            type: 'success',
            message: '调整成功',
            title: '批量调整完成',
          });
          history.goBack();
        } else {
          window.message.toast({
            type: 'error',
            message: res.message,
            title: res.message,
          });
        }
      },
    });
  };
  return (
    <AdjustManyStyled theme={theme}>
      <div
        data-log={JSON.stringify({
          oid: createOid(),
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
      >
        <div className="second-wrapper">
          <Tabs value={Number(tab) - 1} onChange={handleChange}>
            {rightTabArr.map((item, index) => (
              <Tab key={item.key} label={item.name} {...a11yProps(index)} />
            ))}
          </Tabs>

          {rightTabArr.map((i, index) => (
            <TabPanel value={Number(tab) - 1} index={index} key={i.key}>
              <Box className="fab-group">
                <Fab
                  data-log={JSON.stringify({
                    oid: createOid('ec'),
                    events: ['_ev', '_ec'],
                    params: {
                      initUrl:
                        window.location.origin + window.location.pathname,
                    },
                  })}
                  variant="extended"
                  size="small"
                  color="primary"
                  aria-label="add"
                  onClick={i.content.downloadAction}
                >
                  <ArchiveIcon sx={{ width: '24px', height: '24px' }} />
                  {i.content.downloadName}
                </Fab>
                <Import
                  name={i.content.uploadName}
                  onInputChange={(data) => {
                    switch (Number(tab)) {
                      //调整积分
                      case 1:
                        handleData('integralData', data);
                        break;
                      case 2:
                        handleData('levelData', data);
                        break;
                      // //转柜
                      // case 2:
                      //   handleData('storeData', data);
                      //   break;
                      // //等级调整
                      // case 3:
                      //   handleData('levelData', data);
                      //   break;
                      // case 4:
                      //   handleData('serveData', data);
                      //   break;
                      default:
                        return;
                    }
                  }}
                />
              </Box>
              <Box>
                <DataTableNativeML
                  columns={i.content.column}
                  data={
                    (page.pageNum - 1) * page.pageSize > i.content.data.length
                      ? []
                      : i.content.data.slice(
                          (page.pageNum - 1) * page.pageSize,
                          page.pageNum * page.pageSize,
                        )
                  }
                  columnKey="id"
                  total={i.content.data.length}
                  paging={true}
                  page={page}
                  changePage={(pageObj) => {
                    setPage(pageObj);
                  }}
                ></DataTableNativeML>
              </Box>
            </TabPanel>
          ))}
        </div>
        <Box className="button-group">
          <Button
            variant="contained"
            color="secondary"
            className="exit"
            onClick={handleClickExit}
            startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
          >
            退出
          </Button>
          <Button
            data-log={JSON.stringify({
              oid: createOid('ec'),
              events: ['_ev', '_ec'],
              params: {
                initUrl: window.location.origin + window.location.pathname,
              },
            })}
            ref={saveRef}
            variant="contained"
            type="submit"
            className="search"
            startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
            onClick={() => submitChange()}
          >
            确认
          </Button>
        </Box>
      </div>
    </AdjustManyStyled>
  );
};
export default AdjustMany;
